var map = {
	"./": 72812,
	"./App": 52644,
	"./App.css": 44050,
	"./App.js": 52644,
	"./App.test": 87826,
	"./App.test.js": 87826,
	"./components/AwardsComponent": 75308,
	"./components/AwardsComponent.js": 75308,
	"./components/ContactComponent": 43966,
	"./components/ContactComponent.js": 43966,
	"./components/MainComponent": 98491,
	"./components/MainComponent.js": 98491,
	"./components/ProfileComponent": 57177,
	"./components/ProfileComponent.js": 57177,
	"./components/WelcomeComponent": 71444,
	"./components/WelcomeComponent.js": 71444,
	"./components/WelcomeLearnMoreComponent": 14365,
	"./components/WelcomeLearnMoreComponent.js": 14365,
	"./components/WorkComponent": 36609,
	"./components/WorkComponent.js": 36609,
	"./components/WorkshopComponent": 97560,
	"./components/WorkshopComponent.js": 97560,
	"./components/animation.css": 18092,
	"./config/awards": 69742,
	"./config/awards.json": 69742,
	"./config/work": 11893,
	"./config/work.json": 11893,
	"./config/workshops": 14398,
	"./config/workshops.json": 14398,
	"./index": 72812,
	"./index.css": 59555,
	"./index.js": 72812,
	"./jsconfig": 84672,
	"./jsconfig.json": 84672,
	"./logo.svg": 69445,
	"./reportWebVitals": 89031,
	"./reportWebVitals.js": 89031,
	"./setupTests": 89472,
	"./setupTests.js": 89472,
	"./static/images/Doll & House.jpg": 55407,
	"./static/images/awards/AWARD CEREMONY.jpeg": 56697,
	"./static/images/awards/AWARD.jpeg": 38611,
	"./static/images/awards/KALA NIDHI.jpeg": 56409,
	"./static/images/awards/KALA SHRI AWARD.jpeg": 92968,
	"./static/images/awards/STATE AWARD.jpeg": 79930,
	"./static/images/awards/VIJAY DESHMUKH AWARD.jpeg": 56339,
	"./static/images/beti-bacho-beti-padhao.jpg": 59719,
	"./static/images/bg.png": 85339,
	"./static/images/decorative-products.jpg": 30399,
	"./static/images/earrings.jpg": 71427,
	"./static/images/item-before-color.png": 99761,
	"./static/images/kamini-kaushal-2.jpg": 39490,
	"./static/images/kamini-kaushal-3.jpeg": 85496,
	"./static/images/kamini-kaushal-4.jpeg": 38989,
	"./static/images/kamini-kaushal-4.png": 9744,
	"./static/images/kamini-kaushal.png": 96683,
	"./static/images/khal-musal-brushes.png": 56382,
	"./static/images/krishna.jpg": 71266,
	"./static/images/marba.jpg": 8799,
	"./static/images/nativity-set.jpg": 9121,
	"./static/images/pen-stands.jpg": 70595,
	"./static/images/radha-krishna-before-coloring.png": 7087,
	"./static/images/raw-material-2.png": 25435,
	"./static/images/raw-material.png": 80082,
	"./static/images/work/BANGLES.png": 87462,
	"./static/images/work/BIRDS.png": 27220,
	"./static/images/work/BOWL.png": 18066,
	"./static/images/work/BRIDE & GROOM.png": 40688,
	"./static/images/work/COW & CALF.png": 28273,
	"./static/images/work/DIYA.png": 99161,
	"./static/images/work/EAR RINGS.png": 13257,
	"./static/images/work/GANESHJI.png": 41487,
	"./static/images/work/Ghar.png": 9730,
	"./static/images/work/KOTHI.png": 92215,
	"./static/images/work/Lamp Stand.png": 88584,
	"./static/images/work/MARWA.png": 80988,
	"./static/images/work/MOTHER.png": 38807,
	"./static/images/work/Mother 1.png": 20414,
	"./static/images/work/Mother2.png": 81317,
	"./static/images/work/Mother_2.png": 42912,
	"./static/images/work/Mukha.png": 69976,
	"./static/images/work/NATIVITY SET.png": 91082,
	"./static/images/work/PEN STAND.png": 31605,
	"./static/images/work/PLATE1.png": 32115,
	"./static/images/work/PLATE2.png": 57624,
	"./static/images/work/Plate.png": 53144,
	"./static/images/work/Radha-Krishna.png": 77437,
	"./static/images/work/SUN.png": 88374,
	"./static/images/work/TRAY.png": 63186,
	"./static/images/work/lamp-stand.png": 96387,
	"./static/images/work/mandir.png": 88763,
	"./static/images/work/rakhi10.png": 62080,
	"./static/images/work/rakhi2.png": 89105,
	"./static/images/work/rakhi9.png": 86738,
	"./static/images/work/roli.png": 3446,
	"./static/images/work/school.png": 12426,
	"./static/images/workshop/Bombay International School/B1.jpeg": 17493,
	"./static/images/workshop/Bombay International School/B2.jpeg": 2420,
	"./static/images/workshop/Bombay International School/B3.jpeg": 55803,
	"./static/images/workshop/Bombay International School/B4.jpeg": 14938,
	"./static/images/workshop/Bombay International School/B5.jpeg": 64129,
	"./static/images/workshop/Bombay International School/B6.jpeg": 92480,
	"./static/images/workshop/Danji Devshi Kelvani Foundation/D1.jpeg": 74003,
	"./static/images/workshop/Danji Devshi Kelvani Foundation/D2.jpeg": 58086,
	"./static/images/workshop/Danji Devshi Kelvani Foundation/D3.jpeg": 88301,
	"./static/images/workshop/Danji Devshi Kelvani Foundation/D4.jpeg": 34808,
	"./static/images/workshop/Danji Devshi Kelvani Foundation/D5.jpeg": 45295,
	"./static/images/workshop/Patna training center/P1.jpeg": 68772,
	"./static/images/workshop/Patna training center/P2.jpeg": 25765,
	"./static/images/workshop/Patna training center/P3.jpeg": 90206,
	"./static/images/workshop/Patna training center/P4.jpeg": 85127,
	"./static/images/workshop/Patna training center/P5.jpeg": 11728,
	"./static/images/workshop/Patna training center/P6.jpeg": 60017,
	"./static/images/workshop/Shishuban/S1.jpeg": 78409,
	"./static/images/workshop/Shishuban/S2.jpeg": 47080,
	"./static/images/workshop/Shishuban/S3.jpeg": 65599,
	"./static/images/workshop/Shishuban/S4.jpeg": 89718,
	"./static/images/workshop/Shishuban/S5.jpeg": 54813,
	"./static/images/workshop/Shishuban/S6.jpeg": 37148,
	"./static/images/workshop/Training at Jawahar Navoday Vidyalaya , Bihar/J1.jpeg": 53870,
	"./static/images/workshop/Training at Jawahar Navoday Vidyalaya , Bihar/J2.jpeg": 81563,
	"./static/images/workshop/Training at Jawahar Navoday Vidyalaya , Bihar/J3.jpeg": 18228,
	"./static/images/workshop/Women's Day Program at Bihar Museum/W1.jpeg": 40801,
	"./static/images/workshop/Women's Day Program at Bihar Museum/W2.jpeg": 38528,
	"./static/images/workshop/Women's Day Program at Bihar Museum/W3.jpeg": 21751,
	"./static/images/workshop/Women's Day Program at Bihar Museum/W4.jpeg": 97390,
	"./static/images/workshop/Women's Day Program at Bihar Museum/W5.jpeg": 57653,
	"./static/images/workshop/Women's Day Program at Bihar Museum/W6.jpeg": 72148,
	"./static/images/workshop/Women's Day Program at Bihar Museum/W7.jpeg": 18139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;